/** Device Packaging → Distribution (warn-only readiness; partial assignments allowed). */
export { default } from './PackagingToDistributionConfirmDialog';
